module.exports = __webpack_public_path__ + "assets/img/bfac1129556ea28c27e66f79e2290d92.webp";